import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/App";

export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="rounded-full h-9 gap-2 px-2.5"
          data-testid="user-menu-btn"
        >
          <Avatar className="h-6 w-6">
            <AvatarImage src={user?.picture} />
            <AvatarFallback className="text-[10px] bg-neutral-100 text-neutral-600">
              {user?.name?.[0] || "U"}
            </AvatarFallback>
          </Avatar>
          <span className="text-sm text-neutral-700 hidden sm:inline">
            {user?.name}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 rounded-xl p-1.5">
        <DropdownMenuItem className="text-xs text-muted-foreground rounded-lg pointer-events-none">
          {user?.email}
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="logout-btn"
          onClick={handleLogout}
          className="rounded-lg text-destructive"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
